module.exports = __webpack_public_path__ + "static/media/cardSecond.6cecf6c4.png";